<template>
  <div class="ad-plan">
    <div class="panel-header">
      <h3 class="panel-header__title">计划管理</h3>
      <span class="panel-header__subtitle">PLAN MANAGEMENT</span>
      <a class="panel-header__export" v-if="dataUrls" :href="dataUrls">导出</a>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        计划管理
        <el-button type="primary" class="fr" @click="add_plan" v-if="user.id_tag !== 9">
          <b>+&nbsp;</b>
          <i>新增计划</i>
        </el-button>
      </h3>
      <div class="panel-content__select-list">
        <ny-select
          :data="plan.list"
          v-model="plan.value"
          @change="changeSelect"
          :keyValue="['value', 'name']"
          type="plan"
          class="mr5 is-small"
        ></ny-select>
        <el-input v-if="!isAdPut" class="mr5" icon="search" v-model="filterValue"></el-input>
        <ny-select
          v-if="isAdPut"
          :data="put.list"
          v-model="put.value"
          @change="changeSelect"
          :keyValue="['value', 'name']"
          type="put"
          class="mr5 is-small"
        ></ny-select>
        <el-button class="oprSuccess" @click="searchData">搜索</el-button>
        <up-tag
          closable
          type="info"
          size="medium "
          class="panel-content__tag ml20"
          v-if="isTagShow"
          @close="handleClose"
          :disable-transitions="true"
        >
          <span>已筛选的{{plan.value === 'ad_name' ? '广告计划': '广告组'}}名称包含: {{filterValue}}</span>
        </up-tag>
        <div class="fr mr20" v-if="user.id_tag !== 9">
          <el-button @click="batchStartAndStopAd('batchStart', ids)">批量开始</el-button>
          <el-button class="is-warning" @click="batchStartAndStopAd('batchStop', ids)">批量暂停</el-button>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <ny-table
          :page="page"
          selection
          @select-change="handleSelectChange"
          :fixedColumns="{}"
          :slot-columns="['ad_name', 'order_name', 'status_msg']"
          :widthColumns="{id: 166,status_msg: 100, created_at: 160, time: 200, ad_name: 160, order_name:160,  name:160  }"
          @size-change="sizeChange"
          @cell-click="handleCellClick"
          @current-change="currentChange"
        >
          <template slot="ad_name" slot-scope="{ row }">
            <span class="panel-content__table-link">{{row.ad_name }}</span>
          </template>
          <template slot="order_name" slot-scope="{ row }">
            <span class="panel-content__table-link">{{row.order_name }}</span>
          </template>
          <template slot="status_msg" slot-scope="{ row }">
            <div class="panel-content__table-status-box">
              <span
                class="panel-content__table-status"
                :class="{'is-active' : row.status_msg === '已启用'}"
              ></span>
              <span>{{ row.status_msg }}</span>
            </div>
          </template>
          <el-table-column label="开启" align="center" fixed="right" width="60">
            <template slot-scope="scope">
              <template v-if="scope.row.status !== 2 && user.id_tag !== 9">
                <up-switch
                  :value="scope.row.status === 1"
                  @change="handleStartAndStopAd(scope.row, stopStatuses)"
                ></up-switch>
                <!-- <el-tooltip
                  effect="dark"
                  :content="stopStatuses.includes(scope.row.status) ? '启动' : '暂停'"
                  placement="top"
                >
                  <i
                    @click="handleStartAndStopAd(scope.row, stopStatuses)"
                    v-if="stopStatuses.includes(scope.row.status)"
                    class="panel-content__table-icon iconfont icon-play"
                  ></i>
                  <i
                    @click="handleStartAndStopAd(scope.row, stopStatuses)"
                    v-else
                    class="panel-content__table-icon iconfont icon-pause"
                  ></i>
                </el-tooltip>-->
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="240" align="center" fixed="right">
            <template slot-scope="scope">
              <template v-if="scope.row.status !== 2 && user.id_tag !== 9">
                <el-button
                  v-if="scope.row.status !== 1 && scope.row.time_state === 0"
                  @click="edit(scope.row)"
                  size="small"
                  class="is-edit"
                >编辑</el-button>
              </template>

              <el-button size="small" class="is-view" @click="readInfo(scope.row)">查看</el-button>
              <el-button
                v-if="(scope.row.status !== 2 || parseInt(scope.row.is_delete) === 0) && user.id_tag !== 9"
                @click="stop(scope.row, scope.row.id)"
                size="small"
                class="is-remove"
              >停止</el-button>
              <el-button size="small" @click="coypInfo(scope.row)">复制</el-button>
            </template>
          </el-table-column>
        </ny-table>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from '@/global/util/constants';
import qs from 'qs'
import { mapActions, mapGetters } from 'vuex';
import { tip } from '@/global/util/util';
import { NyTable, NySelect } from '@/global/components';
export default {
  components: {
    NyTable,
    NySelect
  },
  data () {
    // this.stopStatuses = [0: '暂停中', '排期已过', '预算不足', '余额不足', '未在投放时间(暂停中)']
    this.stopStatuses = ['排期已过']
    return {
      data: {},
      isAdPut: false,
      isTagShow: false,
      planSelectList: [],
      plan: {
        list: [],
        value: ''
      },
      put: {
        list: [],
        value: ''
      },
      ids: [],
      page: {
        header: {},
        data: [],
        pageSize: 10,
        currentPage: 1,
        total: 0,
        loading: false
      },
      dataUrls: '',
      search_key: '',
      filterValue: '',
      status: [],
      curStatus: 0,
      selectRows: [],
      groupOpr: false
    };
  },
  async created () {
    this.platform = this.$router.currentRoute.meta.platform; // 定义标识当前系统的常量
    const { name, value } = this.$route.query;
    if (name && value) {
      this.isTagShow = true
      this.filterValue = name
    }
    await Promise.all([this.getItem(), this.getStatus()])
    this.plan.value = value
    this.getListPlan()
  },
  computed: {
    ...mapGetters({
      planManage: 'plan/planManage',
      userid: 'login/userid',
      user: 'login/user',
      balance: 'login/balance'
    })
  },
  methods: {
    ...mapActions(['plan/planItem', 'plan/planList', 'plan/planSelect', 'login/getBalanceData', 'plan/batchStart', 'plan/batchStop', 'plan/planStop']),
    async getItem () { // 获取第一个筛选列表
      await this['plan/planSelect']({ data: 'selectlist', platform: this.platform }).then(data => {
        if (data && data.code === 1) {
          this.plan.list = data.data.arr1
          this.plan.value = data.data.arr1[0].value
        }
      })
    },
    dataUrl () {
      let data = {
        page: this.page.currentPage,
        count: 5000,
        [this.plan.value]: this.plan.value === 'status' ? this.put.value : this.filterValue
      }
      this.dataUrls = `${BASE_URL}/${this.platform}/global/ads/export?${qs.stringify(data)}`
    },
    getStatus () { // 获取计划状态列表
      this['plan/planItem']({ data: 'status', platform: this.platform }).then(data => {
        if (data && data.code === 1) {
          this.put.list = data.data
          this.put.value = data.data[0].value
        }
      })
    },
    getListPlan () {
      this.page.loading = true;
      this.$store.dispatch('plan/planList', {
        platform: this.platform,
        data: {
          [this.plan.value]: this.plan.value === 'status' ? this.put.value : this.filterValue,
          page: this.page.currentPage,
          per_page: this.page.pageSize
        }
      }).then((data) => {
        this.page.loading = false;
        if (data && data.code === 1) {
          this.dataUrl()
          this.page.header = data.data.header
          this.page.data = this.platform === 'agency' ? data.data.data.data.data : data.data.data.data
          this.page.total = this.platform === 'agency' ? data.data.data.data.total : data.data.data.total
        }
      });
    },
    changeSelect ({ type, value }) {
      if (type === 'plan' && value === 'status') {
        this.isAdPut = true;
      } else if (type === 'plan' && value !== 'status') {
        this.filterValue = ' ';
        this.isAdPut = false;
      }
      this[type].value = value;
    },
    handleCellClick ({ row, column, cell }) {
      if (['ad_name', 'order_name'].indexOf(column.property) > -1) {
        let path = column.property === 'ad_name' ? '/creations' : '/groups'
        this.$router.push({ path: path, query: { name: row[column.property], value: column.property } })
      }
    },
    async handleStartAndStopAd (row, stopStatuses) {
      // if (row.verify === '已拒绝' || row.verify === '待审核') return tip('审核未通过，广告不可以投放')
      if (row.status !== 2 && stopStatuses.includes(row.status_msg)) {
        return tip(`计划状态为“${row.status_msg}”的计划无法开启！`);
      }
      /* if (row.status === 0) {
        if (this.platform !== 'agency' && this.balance.balance <= 0) {
          return tip('余额不足，请充值！');
        } else if (this.platform === 'agency') {
          const { data } = await this['login/getBalanceData']({
            platform: this.platform,
            data: { account_id: row.user_id, user_type: 4, id_tag: 1 }
          });
          if (data.data.data.balance <= 0) {
            return tip('余额不足，请充值！');
          }
        }
      } */
      const type = row.status === 0 ? 'batchStart' : 'batchStop';
      await this[`plan/${type}`]({
        data: {
          ids: [row.id]
        },
        platform: this.platform
      });
      await this.getListPlan()
    },
    handleSelectChange (selection) {
      this.ids = selection.map(v => v.id)
    },
    async batchStartAndStopAd (type, ids) {
      if (ids.length < 1) { return tip('请至少选择一个计划进行批量操作') }
      let data = await this[`plan/${type}`]({
        platform: this.platform,
        data: {
          ids: ids
        }
      })
      if (data.code === 1) {
        this.getListPlan();
      }
    },
    searchData () {
      this.isTagShow = false
      this.page.currentPage = 1
      this.page.pageSize = 10

      this.getListPlan();
    },
    timeOut (row) {
      // if (row.status === 1) {
      //   this.curStatus = 1;
      // } else if (row.status === 0) {
      //   this.curStatus = 0;
      // }
      this.$store.dispatch('switchOrder', {
        platform: this.platform,
        data: { id: row.id }
      }).then((data) => {
        if (data && data.code === 1) {
          this.getListPlan();
        } else {
          this.$message(data.msg)
        }
      });
    },
    sizeChange (page) { // 当表格显示条数发生变化是触发的函数
      this.page.pageSize = page.pageSize;
      this.getListPlan();
    },
    currentChange (page) { // 当页面发生变化时触发的函数
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.getListPlan();
    },
    add_plan () {
      this.$router.push({ name: 'plan/add' })
    },
    stop (row, id) {
      this.$confirm('“确认永久停止此计划？”', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('plan/planStop', {
          platform: this.platform, data: { ad: id }
        }).then((data) => {
          if (data && data.code === 1) {
            this.$message({
              type: 'success',
              message: '已停止!'
            });
            this.getListPlan();
          }
        });
      });
    },
    handleClose () {
      this.plan.value = ''
      this.filterValue = ''
      this.$router.replace('/plans')
      this.getListPlan()
      this.isTagShow = false
    },
    readInfo (row) {
      this.$router.push({ name: 'plan/view', params: { id: row.id } });
    },
    edit (row) {
      this.$router.push({ name: 'plan/edit', params: { id: row.id } });
    },
    coypInfo (row) {
      this.$router.push({ name: 'plan/copy', params: { id: row.id } });
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
@include b(ad-plan) {
  .el-select-wrapper.is-small {
    .el-select {
      width: 136px;
    }
  }
}
</style>
